const translations = {
  page_title: 'Settings',

  my_profile: 'My profile',
  section_profile: 'Profile',
  section_profile_description:
    'These are your personal data. Keep them updated to make it easier to contact you.',
  section_account: 'Account',
  section_account_description:
    'These are your access credentials. Use a strong password to stay protected.',

  profile_picture: 'Profile picture',
  full_name: 'Full name',
  email: 'Email',
  phone: 'Phone number',
  user_name: 'User name',
  password: 'Password',
  role: 'Role',

  required_field: 'This field is required',
  required_field_short: 'Required',

  change_password: 'Change password',
  current_password: 'Current password',
  new_password: 'New password',
  repeat_new_password: 'Repeat new password',
  no_match_password: 'The new passwords does not match',
  invalid_password: 'Password must be at least 6 characters long and contain letters and numbers.',
  enter_current_password: 'Enter the current password',
  enter_new_password: 'Enter the new password',
  password_changed_success: 'Password changed successfully',
  field_changed_error: 'There was an error',
  current_and_new_password_must_be_different:
    'The current password and new password must be different.',

  first_name: 'First name',
  enter_first_name: 'Enter first name',
  invalid_value: 'Invalid value',

  last_name: 'Last name',
  enter_last_name: 'Enter last name',

  enter_email: 'Enter email',
  invalid_email: 'Invalid email',

  enter_phone: 'Enter phone number',
  invalid_phone: 'Invalid phone number',

  enter_username: 'Enter username',
  invalid_username: 'Invalid username',
  repeated_username: 'The username already exists',
  repeated_email: 'The email already exists',

  profile_updated_successfully: 'Profile updated successfully',
  field_changed_success: 'Field updated successfully',
  picture_updated_successfully: 'Picture updated successfully',

  profile_picture_remove_description: 'Are you sure you want to remove this profile picture?',
};

export default translations;
